<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { bulkUpdate } from 'src/components/DevicesSettings/ApplicationSettings/app_settings_helper';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
	import { real_id } from 'src/helpers/interface_helpers';
	//Design system components
	import { Alert, Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { InputClickEvent } from 'src/types/InputClickEvent';

	export let device: Device;

	const id = device.id;
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let checked = $devices[id].virtual_input || false;
	let disabled = false;

	$: statusStore = getDeviceStatus(id);
	$: status = $statusStore;
	// TODO  This value doesn't updates. Used in Alert, I think we should use checked.
	// $: inputStatus =
	// 	status && btnTypeNotMomentary && input_status_check(status, device);

	const save = async (e: InputClickEvent) => {
		disabled = true;
		checked = e.target.checked;
		const virtual_input = checked;
		const res = await bulkUpdate(id, { virtual_input });

		if (!res?.isok) {
			// Revert to prev value when request fails
			checked = !checked;
		}

		onSettingsResponse(res, device);
		disabled = false;
	};
</script>

<Toggle size="m" {checked} {disabled} class="mb-s" on:click={save} id="toggle-erabvly">
	{$format('virtual_input_label', {
		default: 'Enable virtual events for the input state',
	})}
</Toggle>
